import * as toolbox from 'components/common/toolbox';
import Authorize from 'components/common/authorize';
import Badge from 'components/common/Badge';
import CatchErrors from 'components/common/catch-errors';
import CustomerAccount from 'components/customers/customer/customer-tabs/customer-account';
import InvoicesTab from 'components/invoices/invoices-tab';
import QuotesTab from 'components/quotes/quotes-tab';
import React, { useEffect } from 'react';
import ServiceRequestsTab from 'components/service-requests/service-requests-tab';
import { APPS, LOG, PERMISSIONS } from 'components/constants';
import { Route, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function CustomerTabs(props) {
	
	const seg = 7;
	const match = useRouteMatch();
	const params = useParams();
	const history = useHistory();
	const routeLocation = useLocation();

	const profile = useSelector((store) => store.profiles.profile);

	const segments = routeLocation.pathname.split('/').length;
	const appTabs = {
		[APPS.DISPATCH.id]: ['account', 'service_requests', 'invoices'],
		[APPS.ASSETS.id]: ['account', 'invoices']
	}

	// If tab is not specified, select the first appropriate.
	useEffect(() => {
		if (params.tab == 'tab') {
			let location = toolbox.modifyPath(routeLocation?.pathname, seg, appTabs[params.appId][0], seg);
			history.replace({ pathname: location });
		}
	}, [params.tab]);

	function tab_active(value) {
		return (params.tab === value) ? ' active' : '';
	}
	function link_tab(value, event) {
		event.preventDefault();
		let num = (segments >= 12) ? -2 : (segments >= 10) ? -1 : 0;
		if (num) history.go(num);

		setTimeout(() => {
			history.replace(toolbox.modifyPath(props.location.pathname, seg, value, seg));
		}, 50);
	}

	return (
		
		<div className="tabs-container">
			<ul className="nav nav-tabs underline" role="tablist">
				<li><a className={'nav-link' + tab_active('account')} onClick={link_tab.bind(this, 'account')}>
					<i title="Account" className="fa-duotone fa-solid fa-user fa-2x m-0"></i>
					<br />ACC
				</a></li>
				<Authorize appId={ APPS.DISPATCH.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
					<li className="position-relative">
						<Badge type={'info'} number={profile?.openServiceRequestCount} />
						<a className={'nav-link' + tab_active('service_requests')} onClick={link_tab.bind(this, 'service_requests')}>
							<i title="Open Service Requests" className="fa-duotone fa-solid fa-folder-grid fa-2x m-0"></i>
							<br />SR
						</a>
					</li>
				</Authorize>
				<Authorize appId={ APPS.DISPATCH.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
					<li className="position-relative">
						<Badge type={'info'} number={profile?.serviceHistoryCount} />
						<a className={'nav-link' + tab_active('service_history')} onClick={link_tab.bind(this, 'service_history')}>
							<i title="Service History" className="fa-duotone fa-solid fa-folder-check fa-2x m-0"></i>
							<br />HST
						</a>
					</li>
				</Authorize>
				<Authorize feature={'generate_quotes'} appId={ APPS.DISPATCH.id } perm={ PERMISSIONS.QUOTES_VIEW}>
					<li className="position-relative">
						<Badge type={'info'} number={profile?.quoteCount} />
						<a className={'nav-link' + tab_active('quotes')} onClick={link_tab.bind(this, 'quotes')}>
							<i title="Quotes" className="fa-duotone fa-solid fa-message-quote fa-2x m-0"></i>
							<br />QT
						</a>
					</li>
				</Authorize>
				<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
					<li className="position-relative">
						<Badge type={'info'} number={profile?.invoiceCount} />
						<a className={'nav-link' + tab_active('invoices')} onClick={link_tab.bind(this, 'invoices')}>
							<i title="Invoices" className="fa-duotone fa-solid fa-file-lines fa-2x m-0"></i>
							<br />INV
						</a>
					</li>
				</Authorize>
			</ul>

			<div className="tab-content">
				<div role="tabpanel" className={'tab-pane' + tab_active('account')}>
					<div className="panel-body" style={{ borderBottom: 'none' }}>
						<Route path={match.path} render={(route_props) =>
							<CatchErrors >
								<CustomerAccount />
							</CatchErrors>
						} />
					</div>
				</div>
				<Authorize appId={ APPS.DISPATCH.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
					<div role="tabpanel" className={'tab-pane' + tab_active('service_requests')}>
						<div className="panel-body">
							<Route path={match.path} render={(route_props) =>
								<CatchErrors >
									<ServiceRequestsTab {...route_props} app='1' source="service_requests" />
								</CatchErrors>
							} />
						</div>
					</div>
				</Authorize>
				<Authorize appId={ APPS.DISPATCH.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
					<div role="tabpanel" className={'tab-pane' + tab_active('service_history')}>
						<div className="panel-body">
							<Route path={match.path} render={(route_props) =>
								<CatchErrors >
									<ServiceRequestsTab {...route_props} app='1' source="service_history" />
								</CatchErrors>
							} />
						</div>
					</div>
				</Authorize>
				<Authorize feature={'generate_quotes'} appId={ APPS.DISPATCH.id } perm={ PERMISSIONS.QUOTES_VIEW }>
					<div role="tabpanel" className={'tab-pane' + tab_active('quotes')}>
						<div className="panel-body">
							<Route path={match.path} render={(route_props) =>
								<CatchErrors>
									<QuotesTab {...route_props} source="customers" />
								</CatchErrors>
							} />
						</div>
					</div>
				</Authorize>
				<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
					<div role="tabpanel" className={'tab-pane' + tab_active('invoices')}>
						<div className="panel-body">
							<Route path={match.path} render={(route_props) =>
								<CatchErrors>
									<InvoicesTab {...route_props} 
										prefix="PROFILE" 
										singular="profile"
										source="profiles"
										store="profiles" 
									/>
								</CatchErrors>
							} />
						</div>
					</div>
				</Authorize>
			</div>
		</div>
	);
};

